/** Segco Wholesalers primary storefront categories. */
export const SEGCO_PRIMARY_PRODUCT_CATEGORIES = [
  'Housewares',
  'Appliances',
  'Plumbing',
  'Tools',
  'Toys',
  'Solar Products',
  'Electrical and lighting',
  'Gas Products',
  'Cell Phones',
] as const;

export type SegcoPrimaryCategory = (typeof SEGCO_PRIMARY_PRODUCT_CATEGORIES)[number];

/** Unsplash CDN thumbnails (no API key; `images.unsplash.com`). */
export const SEGCO_CATEGORY_UNSPLASH_IMAGES: Record<SegcoPrimaryCategory, string> = {
  Housewares:
    'https://images.unsplash.com/photo-1556911220-e15b29be8c8f?auto=format&w=480&h=320&fit=crop&q=80',
  Appliances:
    'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&w=480&h=320&fit=crop&q=80',
  Plumbing:
    'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&w=480&h=320&fit=crop&q=80',
  Tools:
    'https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&w=480&h=320&fit=crop&q=80',
  Toys:
    'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?auto=format&w=480&h=320&fit=crop&q=80',
  'Solar Products':
    'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?auto=format&w=480&h=320&fit=crop&q=80',
  'Electrical and lighting':
    'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&w=480&h=320&fit=crop&q=80',
  'Gas Products':
    'https://images.unsplash.com/photo-1615873968403-89e068629265?auto=format&w=480&h=320&fit=crop&q=80',
  'Cell Phones':
    'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&w=480&h=320&fit=crop&q=80',
};

/** Legacy assignable categories (existing catalog / admin). Listed after primaries. */
const LEGACY_ASSIGNABLE_PRODUCT_CATEGORIES = [
  'Electronics',
  'Computers & Accessories',
  'Fashion',
  'Beauty & Personal Care',
  'Home & Kitchen',
  'Sports & Outdoors',
  'Books',
  'Toys & Games',
  'Health & Household',
  'Automotive',
  'Tools & Home Improvement',
  'Grocery & Gourmet Food',
  'Pet Supplies',
  'Baby',
  'Office Products',
  'Garden & Outdoor',
  'Video Games',
  'Luggage & Travel',
  'Jewelry',
  'Watches',
  'Shoes',
  'Handbags',
] as const;

export const ALL_ASSIGNABLE_PRODUCT_CATEGORIES: readonly string[] = [
  ...SEGCO_PRIMARY_PRODUCT_CATEGORIES,
  ...LEGACY_ASSIGNABLE_PRODUCT_CATEGORIES,
];

export function mergeCategoryChoices(extras: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const c of ALL_ASSIGNABLE_PRODUCT_CATEGORIES) {
    if (seen.has(c)) continue;
    seen.add(c);
    out.push(c);
  }
  for (const c of [...extras].sort((a, b) => a.localeCompare(b))) {
    const t = c.trim();
    if (!t || seen.has(t)) continue;
    seen.add(t);
    out.push(t);
  }
  return out;
}
